import { useLocalize } from '@treams/treams-hooks';
import {
	EvaluationCompetencyItem,
	EvaluationFinalScoreItem,
	EvaluationMultipleChoiceItem,
	EvaluationOpenQuestionItem,
	EvaluationReviewGoalsItem,
	EvaluationSentimentItem,
	EvaluationSetGoalsItem,
	EvaluationSignatureItem,
	EvaluationStarsItem,
} from '@treams/treams-network';

type SectionTypes =
	| EvaluationStarsItem
	| EvaluationSignatureItem
	| EvaluationSentimentItem
	| EvaluationReviewGoalsItem
	| EvaluationOpenQuestionItem
	| EvaluationMultipleChoiceItem
	| EvaluationFinalScoreItem
	| EvaluationCompetencyItem
	| EvaluationSetGoalsItem;

/**
 * Return the title from the given SectionTypes item.
 * @param item - The SectionTypes item to map the label from.
 * @returns The mapped label, or undefined if it cannot be mapped.
 */
export const QuestionLabelMapper = (item: SectionTypes) => {
	const { localize } = useLocalize();

	/* Goal reviews check */
	if (item.__typename === 'EvaluationReviewGoalsItem') {
		return localize(item.competencyLevelSet.title).text;
	}

	/* Competency check */
	if (item.__typename === 'EvaluationCompetencyItem') {
		return localize(item.competency.title).text;
	}

	/* Item containing title check */
	if ('title' in item && item.title) {
		return localize(item.title).text;
	}

	/* Otherwise it's a paragraph, section title, etc... which we don't render */
	return undefined;
};
